import request from '@/utils/request'

// 查询会员列表
export function queryShopVipUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryShopVipUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询会员等级
export function queryShopVipLevel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryShopVipLevel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加会员
export function saveShopVipUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/saveShopVipUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改会员
export function updateShopVipUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/updateShopVipUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error) 
    })
  })
}

// 删除会员
export function deleteShopVipUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/deleteShopVipUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出会员
export function exportShopVipUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}